/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Industry.css';
import Ranktable from './../../components/Ranktable'
import Article from './../../components/Article'
import Hotpush from './../../components/Hotpush'
import moment from 'moment'



// 固定导航栏
// import FixedNav from './../../components/FixedNav'


let list=[
	'互联网',
	'互联网金融',
	'手机',
	'汽车',
	'新能源汽车',
	'消费电子',
	'投资',
	'食品',
	'饮料',
	'电脑',
	'家电零售',
	'咖啡/茶饮连锁',
	'快餐连锁',
	'餐饮连锁',
	'生鲜电商',
	'无人零售',
	'超市零售',
	'房地产',
	'银行',
	'短租',
	'网约车',
	'共享出行',
	'时租单车',
	
	'服装零售',
	'运动装备',
	
	'个人护理',
	'化妆品',
	'智能音箱',
	'IT制造',
	'IT服务',
	'OTA',
	'短视频',
	'啤酒',
	'乳业',
	
	'食用油',
	'航空',
	
	'物流',
	
]

class Industry extends React.Component {

	constructor(){
		super()
		this.state={
			listIndex:0,
			time:null
		}
		this.getArtTime=this.getArtTime.bind(this)
	}
	componentWillMount() {
		if(this.state.time==null){
			if(moment().format('a')=='pm'){
        this.setState({time:`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`})
      }else{
        this.setState({time:`${moment().subtract(8,'days').format('YYYY-MM-DD')},${moment().subtract(2,'days').format('YYYY-MM-DD')}`})
      }
		}
	}

	getArtTime=(ss)=>{
		this.setState({time:ss})
	}
	componentWillReceiveProps = (nextProps) => {
		console.log(nextProps)
	}
	

  render() {

		const {listIndex} = this.state

    return (
      <div className={s.root}>
        {/* <div className={s.industry}>
					<ul>
						{list.map((item,index)=>
							<li key={index} className={index==listIndex?s.industryAc:null} onClick={()=>{this.setState({listIndex:index})}}>{item}</li>
						)}
					
					</ul>
				</div> */}
        <Ranktable tit={this.props.childrenData} treeLevel={this.props.treeLevel} rank='industry' getArtTime={this.getArtTime} />
        {/* <Article time={this.state.time} industry={list[listIndex]}/> */}
      </div>
    );
  }
}

export default withStyles(s)(Industry);



// WEBPACK FOOTER //
// src/routes/industry/Industry.js